import { render } from "./Step2.vue?vue&type=template&id=6dd667ac&ts=true"
import script from "./Step2.vue?vue&type=script&lang=ts"
export * from "./Step2.vue?vue&type=script&lang=ts"

import exportComponent from "/home/meiyeer/irb-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__